var map = {
	"./bch.png": 29264,
	"./bnb.png": 78405,
	"./bsv.png": 83790,
	"./btc.png": 83714,
	"./eth.png": 38766,
	"./no-coin.png": 21106,
	"./usd.png": 12751,
	"./usdc.png": 37460,
	"./usdt.png": 94363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13110;